const testimonials = [
  {
    name: 'Jennifer M.',
    state: 'Ohio',
    rating: 5,
    badge: 'D1 Full Scholarship',
    badgeIcon: 'ri-trophy-fill',
    badgeColor: 'bg-[#f5a623]/20 text-[#f5a623] border-[#f5a623]/30',
    sport: 'Soccer',
    quote:
      "I was completely lost before finding The Recruiting Playbook. My daughter had talent, but coaches weren't responding. We followed the email templates in Phase 2 and within 3 weeks had 4 programs interested. She signed with her dream D1 school — full ride. This guide paid for itself a thousand times over.",
    initials: 'JM',
    avatarColor: 'bg-[#f5a623]',
  },
  {
    name: 'Marcus T.',
    state: 'Texas',
    rating: 5,
    badge: '60% Athletic Scholarship',
    badgeIcon: 'ri-medal-fill',
    badgeColor: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    sport: 'Football',
    quote:
      'My son is a junior and we started late — or so I thought. The roadmap showed me exactly what to prioritize in the final stretch. The coach tracker alone changed everything. We went from zero responses to multiple scholarship offers in one semester. The $47 was the best investment I made for his future.',
    initials: 'MT',
    avatarColor: 'bg-emerald-500',
  },
  {
    name: 'Sarah K.',
    state: 'California',
    rating: 5,
    badge: 'D2 Full Scholarship',
    badgeIcon: 'ri-star-fill',
    badgeColor: 'bg-sky-500/20 text-sky-400 border-sky-500/30',
    sport: 'Swimming',
    quote:
      "As a single mom, I was terrified I wouldn't be able to navigate this on my own. The Recruiting Playbook broke everything down in plain language. The highlight video blueprint alone was worth it — my daughter's video went from ignored to getting shared by coaches. She's getting a full D2 scholarship next fall.",
    initials: 'SK',
    avatarColor: 'bg-sky-500',
  },
];

export default function SocialProofSection() {
  return (
    <section id="testimonials" className="bg-[#0a1628] py-20 md:py-28 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-20 left-10 text-[200px] font-display font-bold text-white/[0.02] leading-none select-none pointer-events-none">
        &ldquo;
      </div>
      <div className="absolute bottom-10 right-10 text-[200px] font-display font-bold text-white/[0.02] leading-none select-none pointer-events-none">
        &rdquo;
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#f5a623]/10 border border-[#f5a623]/30 rounded-full px-4 py-2 mb-6">
            <i className="ri-star-fill text-[#f5a623] text-sm" />
            <span className="text-[#f5a623] font-body text-xs font-semibold uppercase tracking-widest">Real Results</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase leading-tight">
            Parents Who
            <span className="block text-[#f5a623]">Won the Game.</span>
          </h2>
          <p className="font-body text-lg text-white/60 max-w-2xl mx-auto mt-4">
            These aren't lucky stories. They're the result of following a proven system.
          </p>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto mb-14">
          {[
            { value: '500+', label: 'Families Served' },
            { value: '$2M+', label: 'Scholarships Secured' },
            { value: '4.9★', label: 'Average Rating' },
          ].map((stat) => (
            <div key={stat.label} className="text-center bg-[#122040] border border-white/10 rounded-xl py-5 px-3">
              <div className="font-display text-2xl md:text-3xl font-bold text-[#f5a623]">{stat.value}</div>
              <div className="font-body text-xs text-white/50 mt-1 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonial cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#122040] border border-white/10 rounded-2xl p-6 md:p-7 flex flex-col gap-5 hover:border-[#f5a623]/30 transition-colors duration-300"
            >
              {/* Star rating */}
              <div className="flex items-center gap-1">
                {Array.from({ length: t.rating }).map((_, j) => (
                  <div key={j} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#f5a623] text-base" />
                  </div>
                ))}
              </div>

              {/* Quote */}
              <p className="font-body text-sm text-white/75 leading-relaxed flex-1">
                &ldquo;{t.quote}&rdquo;
              </p>

              {/* Badge */}
              <div className={`inline-flex items-center gap-2 border rounded-full px-3 py-1.5 self-start ${t.badgeColor}`}>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${t.badgeIcon} text-base`} />
                </div>
                <span className="font-body text-xs font-bold uppercase tracking-wide">{t.badge}</span>
              </div>

              {/* Author */}
              <div className="flex items-center gap-3 pt-2 border-t border-white/10">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${t.avatarColor} flex-shrink-0`}>
                  <span className="font-display text-sm font-bold text-[#0a1628]">{t.initials}</span>
                </div>
                <div>
                  <p className="font-body text-sm font-semibold text-white">{t.name}</p>
                  <p className="font-body text-xs text-white/40">{t.sport} Parent · {t.state}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
